export function getBaseUrlIdentity (): string {
  return process.env.REACT_APP_IDENTITY ?? ''
}
